import React, { useState, useRef } from 'react';
import { Form, Typography } from 'antd';
import { useTheme } from '../../contexts/ThemeContext';
import Modal from './Modal';
import { DynamicForm } from '../form/DynamicForm';

const { Title } = Typography;

const FormModal = ({
  title,
  open,
  onCancel,
  onSave,
  formConfig,
  initialValues = {},
  loading = false,
  width = 600,
  submitText = 'Salvar',
  cancelText = 'Cancelar',
  validateOnSubmit = true,
  resetOnClose = true,
  ...props
}) => {
  const { theme } = useTheme();
  const [form] = Form.useForm();
  const [formLoading, setFormLoading] = useState(false);
  const formRef = useRef(null);

  const handleSave = async () => {
    if (!onSave) return;

    try {
      setFormLoading(true);
      
      if (validateOnSubmit) {
        const values = await form.validateFields();
        await onSave(values, form);
      } else {
        const values = form.getFieldsValue();
        await onSave(values, form);
      }
      
      if (resetOnClose) {
        form.resetFields();
      }
    } catch (error) {
      console.error('Erro ao validar formulário:', error);
      // Não fechar o modal se houver erro de validação
    } finally {
      setFormLoading(false);
    }
  };

  const handleCancel = () => {
    if (resetOnClose) {
      form.resetFields();
    }
    onCancel?.();
  };

  return (
    <Modal
      title={
        <Title level={4} style={{ margin: 0, color: theme.textSecondary }}>
          {title}
        </Title>
      }
      open={open}
      onCancel={handleCancel}
      onOk={handleSave}
      okText={submitText}
      cancelText={cancelText}
      variant="form"
      width={width}
      loading={loading || formLoading}
      okButtonProps={{
        style: { borderRadius: '6px' }
      }}
      cancelButtonProps={{
        style: { borderRadius: '6px' }
      }}
      {...props}
    >
      <div style={{ padding: '8px 0' }}>
        <Form
          form={form}
          layout="vertical"
          initialValues={initialValues}
          preserve={false}
          scrollToFirstError
        >
          <DynamicForm
            ref={formRef}
            formConfig={formConfig}
            form={form}
            initialValues={initialValues}
            showSubmitButton={false}
            showCancelButton={false}
          />
        </Form>
      </div>
    </Modal>
  );
};

export default FormModal;